import { TestimonialItem } from "@/types/testimonial";

export const testimonialsData: TestimonialItem[] = [
  {
    id: "test-01",
    quote:
      "The Quality Collection Private Limited transformed our concept into premium handcrafted products with exceptional attention to detail. Their team's expertise and communication made the entire development process seamless.",
    authorImage: "/images/testimonials/avatar1.webp",
    role: "PRODUCT DEVELOPMENT MANAGER, USA",
    rating: 5,
  },
  {
    id: "test-02",
    quote:
      "From sampling to final production, every shipment exceeded our quality expectations. They have become a trusted manufacturing partner for our international sourcing needs.",
    authorImage: "/images/testimonials/avatar2.webp",
    role: "IMPORTER & WHOLESALE BUYER, GERMANY",
    rating: 5,
  },
  {
    id: "test-03",
    quote:
      "Their ability to manufacture completely customized products from simple sketches is remarkable. Every finish reflects outstanding craftsmanship and world-class quality.",
    authorImage: "/images/testimonials/avatar3.webp",
    role: "INTERIOR DESIGN STUDIO, UAE",
    rating: 5,
  },
  {
    id: "test-04",
    quote:
      "Professional communication, reliable delivery schedules, and consistent product quality make The Quality Collection Private Limited one of our most dependable export partners.",
    authorImage: "/images/testimonials/avatar4.webp",
    role: "GLOBAL SOURCING DIRECTOR, UNITED KINGDOM",
    rating: 5,
  },
];